document.documentElement.classList.add("js");

document.addEventListener("DOMContentLoaded", () => {
  const successMessage = document.querySelector(".form-status--success");
  if (successMessage) {
    successMessage.setAttribute("tabindex", "-1");
    successMessage.focus();
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const targetId = link.getAttribute("href");
      if (!targetId || targetId === "#") return;
      const target = document.querySelector(targetId);
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      history.replaceState(null, "", targetId);
    });
  });
});
